import moment from 'moment';
import { ACTIONCOMMON, ACITONCOPYRIGHT } from '../actionTypes';
export function uploadImg(payload, callback, errorCallback) {
	return {
		type: ACTIONCOMMON.FETCH_COMMON_UPLOAD,
		payload,
		callback,
		errorCallback
	};
}
export function getAuth(payload, callback, errorCallback) {
	return {
		type: ACTIONCOMMON.FETCH_COMMON_AUTH,
		payload,
		callback,
		errorCallback
	};
}
export function getHomepageStatus(payload, callback, errorCallback) {
	return {
		type: ACTIONCOMMON.FETCH_COMMON_HOMEPAGESTATUS,
		payload,
		callback,
		errorCallback
	};
}
export function setHomepageStatus(payload, callback, errorCallback) {
	return {
		type: ACTIONCOMMON.FETCH_COMMON_SETSHOMEPAGESTATUS,
		payload,
		callback,
		errorCallback
	};
}
export function setHomepageDomainName(payload, callback, errorCallback) {
	return {
		type: ACTIONCOMMON.FETCH_COMMON_SETDOMIANAME,
		payload,
		callback,
		errorCallback
	};
}
export function actionCopyrightUpload(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_COPYRIGHT_UPLOADIMG,
		payload,
		callback,
		errorCallback
	};
}
export function getCopyrightUserInfo(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_USER_INFO,
		payload,
		callback,
		errorCallback
	};
}
